import { useMutation } from "react-query";
import { useDispatch } from "react-redux";
import {
  createAuthenticatedRequest,
  defaultMutationOptions,
  executeRequest,
} from "./utils";

export const SERVICES_PATH = "services";

export function useRescrapeUsers() {
  const dispatch = useDispatch();

  const path = `${SERVICES_PATH}/rescrapeUsers`;

  return useMutation(body => rescrapeUsers(path, body, dispatch), {
    ...defaultMutationOptions,
  });
}

/**
 * Execute a PUT request to rescrapeUsers
 * @param {string} path - The API path
 * @param {Object} body - Request body containing:
 * @param {Array<string>} body.userIds - Array of userIds to rescrape
 * @param {string} [body.profileLocation] - Profile location to use for mongo. If null, use profile's existing location
 * @param {string} [body.type] - PROFILE_PLATFORM.INSTAGRAM or PROFILE_PLATFORM.TIKTOK, default INSTAGRAM
 * @param {boolean} [body.createMongoUser] - Create a Mongo user, default false
 * @param {boolean} [body.returnMongoUsers] - Return Mongo users, default false
 * @param {boolean} [body.saveProfilePic] - Save profile pictures, default false
 * @param {boolean} [body.saveThumbnails] - Save thumbnails, default false
 * @param {Function} dispatch - Redux dispatch function
 */
export async function rescrapeUsers(path, body, dispatch) {
  const requestObject = await createAuthenticatedRequest(path, dispatch, {
    method: "PUT",
    body: JSON.stringify(body),
  });

  return executeRequest(requestObject);
}

export function useScrapeLink() {
  const dispatch = useDispatch();

  const path = `${SERVICES_PATH}/scrapeLink`;

  return useMutation(body => scrapeLink(path, body, dispatch), {
    ...defaultMutationOptions,
  });
}

// Execute a POST request to scrapeLink
export async function scrapeLink(path, body, dispatch) {
  const requestObject = await createAuthenticatedRequest(path, dispatch, {
    method: "POST",
    body: JSON.stringify(body),
  });

  const response = await fetch(requestObject);
  if (!response.ok) {
    const json = await response.json();
    throw new Error(json.message || response.statusText);
  }
  return response.text();
}
